var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 19.941,
    viewBox: "0 0 29 19.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-text_2_",
    "data-name": "list-text (2)",
    transform: "translate(-0.001 -80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4649",
    "data-name": "Group 4649",
    transform: "translate(5.446 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4648",
    "data-name": "Group 4648",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13879",
    "data-name": "Path 13879",
    d: "M116.111,80H97.992a1.812,1.812,0,1,0,0,3.624h18.119a1.812,1.812,0,1,0,0-3.624Z",
    transform: "translate(-96.18 -80)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4651",
    "data-name": "Group 4651",
    transform: "translate(0.001 80.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13880",
    "data-name": "Path 13880",
    d: "M3.635,81.939a1.812,1.812,0,0,0-3.624,0,1.543,1.543,0,0,0,0,.353,1.633,1.633,0,0,0,.1.344,2.1,2.1,0,0,0,.172.308,1.657,1.657,0,0,0,.226.281,1.6,1.6,0,0,0,.272.217,1.476,1.476,0,0,0,.308.172,1.5,1.5,0,0,0,.38.136,1.588,1.588,0,0,0,.353,0A1.812,1.812,0,0,0,3.1,83.225a1.657,1.657,0,0,0,.226-.281,2.1,2.1,0,0,0,.172-.308,1.682,1.682,0,0,0,.136-.344A1.543,1.543,0,0,0,3.635,81.939Z",
    transform: "translate(-0.001 -80.135)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4653",
    "data-name": "Group 4653",
    transform: "translate(0.011 88.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4652",
    "data-name": "Group 4652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13881",
    "data-name": "Path 13881",
    d: "M3.8,225.939a1.549,1.549,0,0,0,0-.353,1.468,1.468,0,0,0-.136-.335,1.812,1.812,0,0,0-.172-.317,1.305,1.305,0,0,0-.226-.272A1.812,1.812,0,0,0,.18,225.939a1.807,1.807,0,0,0,.3,1.006,1.738,1.738,0,0,0,.236.272,1.323,1.323,0,0,0,.272.226,1.469,1.469,0,0,0,.308.172,1.542,1.542,0,0,0,.344.1,1.5,1.5,0,0,0,.353.036,1.544,1.544,0,0,0,.353,0,1.469,1.469,0,0,0,.335-.1A1.513,1.513,0,0,0,3,227.479a1.322,1.322,0,0,0,.272-.226,1.323,1.323,0,0,0,.226-.272,1.457,1.457,0,0,0,.172-.308,1.533,1.533,0,0,0,.136-.38A1.5,1.5,0,0,0,3.8,225.939Z",
    transform: "translate(-0.18 -224.135)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4655",
    "data-name": "Group 4655",
    transform: "translate(0.011 96.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4654",
    "data-name": "Group 4654",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13882",
    "data-name": "Path 13882",
    d: "M3.8,369.939a1.556,1.556,0,0,0,0-.353,1.542,1.542,0,0,0-.136-.344,2.1,2.1,0,0,0-.172-.308,1.325,1.325,0,0,0-.226-.272,1.812,1.812,0,0,0-2.555,0,1.325,1.325,0,0,0-.226.272,2.1,2.1,0,0,0-.172.308,1.485,1.485,0,0,0-.1.344,1.557,1.557,0,0,0-.036.353,1.812,1.812,0,0,0,.535,1.277,1.324,1.324,0,0,0,.272.226,1.469,1.469,0,0,0,.308.172,1.539,1.539,0,0,0,.344.1,1.506,1.506,0,0,0,.353.036,1.544,1.544,0,0,0,.353,0,1.47,1.47,0,0,0,.335-.1A1.511,1.511,0,0,0,3,371.479a1.324,1.324,0,0,0,.272-.226,1.323,1.323,0,0,0,.226-.272,1.451,1.451,0,0,0,.172-.308,1.538,1.538,0,0,0,.136-.38A1.5,1.5,0,0,0,3.8,369.939Z",
    transform: "translate(-0.178 -368.135)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4657",
    "data-name": "Group 4657",
    transform: "translate(5.446 88.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4656",
    "data-name": "Group 4656",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13883",
    "data-name": "Path 13883",
    d: "M117.922,224H97.992a1.812,1.812,0,0,0,0,3.624h19.931a1.812,1.812,0,0,0,0-3.624Z",
    transform: "translate(-96.18 -224)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4659",
    "data-name": "Group 4659",
    transform: "translate(5.446 96.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4658",
    "data-name": "Group 4658",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13884",
    "data-name": "Path 13884",
    d: "M109.769,368H97.992a1.812,1.812,0,1,0,0,3.624h11.777a1.812,1.812,0,1,0,0-3.624Z",
    transform: "translate(-96.18 -368)",
    fill: "#f5f5f5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.559dfa1700f9e6438438eee0014fb355.svg";
export { ForwardRef as ReactComponent };